        <template v-slot:default="{ hide }">

            <div class="px-3 py-2">
                        
                <div v-for="(row1, index) in grid_options" :key="index"> 
                    <div v-if="row1.options.length == 0 && default_column.includes(row1.label) && row1.type !='date'">                            
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="list"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" :placeholder="stringView(row1.label)" :name="row1.label" v-model="search_by_filter[row1.label]" ></b-form-input>
                        </b-input-group>
                    </div>  

                    <div v-if="row1.options.length == 0 && default_column.includes(row1.label) && row1.type =='date'">                        
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="list"></b-icon>
                            </b-input-group-prepend>
                            
                            <b-form-input :placeholder="stringView(row1.label)" :name="row1.label" v-model="search_by_filter[row1.label]"></b-form-input>
                            <b-form-datepicker id="day_one"  button-only right locale="en-US"  v-model="search_by_filter[row1.label]"></b-form-datepicker>
                        </b-input-group>
                    </div>    
                </div> 
                <div v-for="(row2, index2) in grid_options" :key="row2.label"> 
                    <div v-if="row2.options.length > 0 && default_column.includes(row2.label)">  
                        <div v-if="filter_by_id.includes(row2.label)">
                            
                            <b-input-group class="mb-2">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="list"></b-icon>
                                </b-input-group-prepend>
                                <select :name="row2.label" class='form-control' v-model="search_by_filter[row2.label+'_id']">
                                    <option value='' >Select {{stringView(row2.label)}}</option>
                                    <option v-for='data in row2.options' :value='data.id' :key="data.id+data.name">{{ data.name }}</option>
                                </select>
                            </b-input-group> 
                        </div>           
                        <div v-else>    
                            <b-input-group class="mb-2">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="list"></b-icon>
                                </b-input-group-prepend>
                                <select :name="row2.label" class='form-control' v-model='search_by_filter[row2.label]'>
                                    <option value='' >Select {{stringView(row2.label)}}</option>
                                    <option v-for='data in row2.options' :value='data.id' :key="data.id+data.name">{{ data.name }}</option>
                                </select>
                            </b-input-group> 
                        </div>
                    </div>   
                </div>
                
                <div class="mt-4" >
                    <b-button class="filter_btn" v-b-toggle.sidebar_right variant="outline-secondary" block  title="Set Filter"><div>Set Filter</div></b-button>
                    <b-button class="filter_btn" variant="outline-secondary" block  title="Clear Filter" @click="resetFlter();"><div>Clear Filter</div></b-button>
                </div>
            </div>
        </template>


<script>
    export default{
        props: ['grid_options','search_by_filter','default_column'],        
        
        data(){ 
            return {
                filter_by_id:['jobposition','department','branch'],
                filter_by_id_options:[{jobposition:"jobposition_id"},{department:"department_id"},{branch:"branch_id"}],
            }   
        },
        methods:{

            generateFilterOptions: function()
            { 
                let value = [];
                value['reset'] = 0;
                value['search_by_filter'] = this.search_by_filter;
                this.$emit('childToParent',value);
                
            },
            stringView(str) {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            resetFlter: function()
            {    
                let value = [];
                value['reset'] = 1;
                let cr = this.search_by_filter;
                let defaultval = {};
                Object.keys(this.search_by_filter).forEach(key => {
                    
                    defaultval[key] = '';
                });
                value['search_by_filter'] = defaultval;
                this.$emit('childToParent',value); 
            },
        },
        created: function()
        {
            this.generateFilterOptions();
        }
    }
</script>